import React from "react";

const CardAatb = (props) => {
    const { chk, setChk, aatb } = props;

    return (
        <li className={chk === aatb.AATB_SEQ ? "active" : ""}>
            <a onClick={(e) => (chk === aatb.AATB_SEQ ? setChk(-1) : setChk(aatb.AATB_SEQ))}>
                <span className="img">
                    <img src={aatb.AATB_THUMB} alt={aatb.COURSE_GRP_CD} data-id={aatb.AATB_SEQ} />
                </span>
                <span className="text">{aatb.PBCM_NAME} {Boolean(aatb.AUTR_YN) && aatb.AUTR_YN === "Y" ? "(" + aatb.AUTR_NAME + ")" : ""}</span>
            </a>
        </li>
    );
};

export default CardAatb;
